@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.progress-bar-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  background: @progress-bar--wrapper--background-color;

  &.indefinite-progress-bar {
    .progress-bar {
      position: absolute;
      top: 0;
      transition: none;
      animation: indefinite-animation 1000ms linear infinite;
    }
  }
}

.progress-bar {
  height: 100%;
  transition: all 300ms ease;
  background: @progress-bar--theme-primary--background-color;

  &.theme-create {
    background: @progress-bar--theme-create--background-color;
  }

  &.theme-danger {
    background: @progress-bar--theme-danger--background-color;
  }

  &.theme-warning {
    background: @progress-bar--theme-warning--background-color;
  }
}

@keyframes indefinite-animation {
  0% {
    left: 0;
    right: 100%;
  }
  20% {
    left: 0;
    right: 60%;
  }
  80% {
    left: 60%;
    right: 0;
  }
  100% {
    left: 100%;
    right: 0;
  }
}
